import { setLocalItem } from '../../store/localStore';
export function destinationTypeEventManager(form) {
    const destinationTypeCards = document.querySelectorAll('.qq__card.destination-type');
    destinationTypeCards.forEach((card) => {
        card.addEventListener('click', (event) => {
            destinationTypeCards.forEach((card) => {
                card.classList.remove('active-card');
            });
            card.classList.add('active-card');
            card.scrollIntoView({ behavior: 'smooth', block: 'center' });
            document
                .getElementById('qq-destination-type')
                .classList.remove('error', 'required');
            const inputElement = card.querySelector('input[type="radio"]');
            if (inputElement) {
                const dataValue = inputElement.value;
                form.set('area', dataValue);
                setLocalItem('area', dataValue); // Store in local storage
            }
            else {
                console.error('Input element not found');
            }
        });
    });
}
